export default "__VITE_ASSET__BM1AnFLj__"